import { InquiryForm } from "../components/InquiryForm";
import { motion } from "framer-motion";
import ImageCarousel from "../components/ImageCarousel";

export const Contact: React.FC = () => (
  <main className="min-h-screen bg-gradient-to-b from-yellow-100 via-white to-blue-100 py-10 overflow-x-hidden">
    <div className="relative h-80 w-full mb-16">
      <ImageCarousel autoPlay={true} interval={4000} />
      <div className="absolute inset-0 flex flex-col justify-center items-center text-white text-center z-10">
        <motion.h1
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="text-5xl font-bold drop-shadow"
        >
          Contact Us
        </motion.h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.7 }}
          className="text-lg mt-2 text-white bg-[#0A2342] px-4 py-2 rounded-md shadow-md"
        >
          We’re here to help you with your questions
        </motion.p>
      </div>
    </div>

    {/* Info & Form */}
    <div className="max-w-6xl mx-auto px-4 grid md:grid-cols-2 gap-8 items-start">
      {/* Contact Info */}
      <motion.div
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6 }}
        className="bg-white rounded-xl shadow-xl p-6 space-y-4"
      >
        <div className="inline-flex items-center gap-2 bg-yellow-100 border-l-4 border-yellow-400 px-4 py-2 rounded shadow-sm mb-2">
          <h2 className="text-2xl font-bold text-blue-900">Contact Info</h2>
        </div>
        <div className="space-y-3 text-gray-700 text-base leading-relaxed">
          <div>
            🧑‍🏫 <strong>Director:</strong> Ashna P Singh
          </div>
          <div>
            📍 <strong>Head Office Address:</strong>
            <br />
            H.No. 122, Vimal Vihar, Near Parinay Marriage Hall,
            <br />
            Agra - 282007, Uttar Pradesh
          </div>
          <div>
            📍 <strong>Campus Address:</strong>
            <br />
            Village Agarpur, Agra–Jalesar Road, Agra,
            <br />
            Agra - 282007, Uttar Pradesh
          </div>
          <div>
            📞 <strong>Call Us:</strong>
            <br />
            +91-9997450792, 9997450793
          </div>
          <div>
            ✉️ <strong>Email:</strong>
            <br />
            <a
              href="mailto:haifadefenceacademy@gmail.com"
              className="text-blue-800 hover:underline"
            >
              haifadefenceacademy@gmail.com
            </a>
          </div>
          <div>
            🏢 <strong>Company:</strong> Haifa Defence Academy
          </div>
        </div>
      </motion.div>

      {/* Inquiry Form */}
      <motion.div
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6 }}
        className="bg-white rounded-xl shadow-xl p-6"
      >
        <div className="inline-flex items-center gap-2 bg-yellow-100 border-l-4 border-yellow-400 px-4 py-2 rounded shadow-sm mb-4">
          <h2 className="text-2xl font-bold text-blue-900">Send Us a Query</h2>
        </div>
        <p className="text-gray-600 mb-6">
          Have any questions or want to register? Fill out the form below.
        </p>
        <InquiryForm />
      </motion.div>
    </div>

    {/* WhatsApp CTA */}
    <a
      href="https://wa.me/919997450792?text=Hi%20I%20am%20interested%20in%20your%20academy%20program"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white px-5 py-3 rounded-full transition-all duration-300 animate-pulse font-semibold shadow-lg"
      title="Chat on WhatsApp"
      style={{
        boxShadow: `
          0 0 15px rgba(0, 255, 0, 0.6),
          0 0 25px rgba(0, 255, 0, 0.5),
          0 4px 10px rgba(0, 0, 0, 0.3)
        `,
      }}
    >
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
        alt="WhatsApp"
        className="h-8 w-8"
      />
      <span className="hidden sm:inline">Chat</span>
    </a>
  </main>
);
